const SUPPORT_TYPES = {
    GET_ALL_TICKETS: "GET_ALL_TICKETS",
    GET_ALL_TICKETS_LOADING: "GET_ALL_TICKETS_LOADING",
    GET_ALL_TICKETS_SUCCESS: "GET_ALL_TICKETS_SUCCESS",
    GET_ALL_TICKETS_ERROR: "GET_ALL_TICKETS_ERROR",
    GET_ALL_TICKETS_RESET: "GET_ALL_TICKETS_RESET",

    CREATE_TICKET: "CREATE_TICKET",
    CREATE_TICKET_LOADING: "CREATE_TICKET_LOADING",
    CREATE_TICKET_SUCCESS: "CREATE_TICKET_SUCCESS",
    CREATE_TICKET_ERROR: "CREATE_TICKET_ERROR",
    CREATE_TICKET_RESET: "CREATE_TICKET_RESET",

    UPDATE_TICKET: "UPDATE_TICKET",
    UPDATE_TICKET_LOADING: "UPDATE_TICKET_LOADING",
    UPDATE_TICKET_SUCCESS: "UPDATE_TICKET_SUCCESS",
    UPDATE_TICKET_ERROR: "UPDATE_TICKET_ERROR",
    UPDATE_TICKET_RESET: "UPDATE_TICKET_RESET",

    UPDATE_TICKET_RESPONSE: "UPDATE_TICKET_RESPONSE",
    UPDATE_TICKET_RESPONSE_LOADING: "UPDATE_TICKET_RESPONSE_LOADING",
    UPDATE_TICKET_RESPONSE_SUCCESS: "UPDATE_TICKET_RESPONSE_SUCCESS",
    UPDATE_TICKET_RESPONSE_ERROR: "UPDATE_TICKET_RESPONSE_ERROR",
    UPDATE_TICKET_RESPONSE_RESET: "UPDATE_TICKET_RESPONSE_RESET",

    GET_TICKET_BY_ID: "GET_TICKET_BY_ID",
    GET_TICKET_BY_ID_LOADING: "GET_TICKET_BY_ID_LOADING",
    GET_TICKET_BY_ID_SUCCESS: "GET_TICKET_BY_ID_SUCCESS",
    GET_TICKET_BY_ID_ERROR: "GET_TICKET_BY_ID_ERROR",
    GET_TICKET_BY_ID_RESET: "GET_TICKET_BY_ID_RESET",
}

export default SUPPORT_TYPES